import { GzNsxWebComponent } from './component/GzNsxWebComponent';

export { GzNsxWebComponent };
